import axios, { AxiosError } from "axios";

import { API_URL } from "@/shared/config";

export interface IApiError {
  errorKey: string;
  errorText: string;
}

export const $axios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

$axios.interceptors.request.use((request) => {
  return request;
});

$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError<IApiError>) => {
    return Promise.reject(error);
  }
);
